(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9854,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fwiki%2F%5Bslug%5D%2Fevents.tsx&page=%2Fwiki%2F%5Bslug%5D%2Fevents!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/[slug]/events",
      function () {
        return __webpack_require__("./src/pages/wiki/[slug]/events.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/pages/NotFound.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _components_Elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/@chakra-ui/image/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/next/router.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);





const WikiNotFound = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const isWiki = router.query.tags ? false : true;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
        w: {
            base: "100%"
        },
        alignItems: {
            base: "center"
        },
        justifyContent: {
            base: "center"
        },
        direction: {
            base: "column"
        },
        mt: {
            base: "9"
        },
        pb: {
            base: "96"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                w: {
                    lg: "15%",
                    base: "40%"
                },
                alignItems: {
                    base: "center"
                },
                justifyContent: {
                    base: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .Ee, {
                    flex: 1,
                    marginInlineStart: "0 !important",
                    src: "/images/defaults/wiki-error-img.png",
                    w: {
                        base: "100%",
                        sm: "80%",
                        md: "60%",
                        lg: "15%"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                mt: {
                    lg: "32",
                    base: "12"
                },
                textAlign: "center",
                children: isWiki ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                            fontWeight: "bold",
                            fontSize: "2xl",
                            children: "Opps! Wiki not found"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements__WEBPACK_IMPORTED_MODULE_2__/* .LinkButton */ .Qj, {
                            href: "/create-wiki",
                            mt: {
                                lg: "7",
                                base: "6"
                            },
                            children: "Create Wiki"
                        }),
                        " "
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                            fontWeight: "bold",
                            fontSize: "2xl",
                            children: "Oops, No Wiki Found with this Tag"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
                            mt: {
                                lg: "5",
                                base: "3"
                            },
                            colorScheme: "primary",
                            color: "white",
                            variant: "solid",
                            onClick: ()=>router.back(),
                            children: "Go Back"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WikiNotFound);


/***/ }),

/***/ "./src/pages/wiki/[slug]/events.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ events; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Wiki/Event/EventCard.tsx





const EventCard = (param)=>{
    let { title , eventDate , description , link  } = param;
    const date = new Date(eventDate);
    const formattedDate = date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        pos: "relative",
        zIndex: 2,
        gap: {
            base: "4",
            xl: "6"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                w: {
                    base: "20px",
                    md: "24px"
                },
                h: {
                    base: "20px",
                    md: "24px"
                },
                borderRadius: "50%",
                bgColor: "brandLinkColor",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                    color: "white",
                    as: ri_index_esm/* RiArrowRightUpLine */.wpV
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                bgColor: "cardBg",
                flexGrow: "1",
                flexBasis: "100%",
                borderRadius: "16px",
                p: "5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        fontSize: {
                            base: "14px",
                            xl: "24px"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        mt: {
                            base: 0.5,
                            md: "1.5"
                        },
                        fontSize: {
                            base: "12px",
                            xl: "18px"
                        },
                        color: "eventTextColor",
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        mt: {
                            base: 1,
                            md: "2"
                        },
                        color: "eventTextColor",
                        fontSize: {
                            base: "12px",
                            xl: "16px"
                        },
                        children: description
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        gap: "2",
                        alignItems: "center",
                        mt: "4",
                        fontSize: {
                            base: "12px",
                            xl: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                as: ri_index_esm/* RiLink */._q$,
                                color: "brandLinkColor"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                noOfLines: 1,
                                maxW: "70vw",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                href: link,
                                target: "_blank",
                                color: "brandLinkColor",
                                children: link
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Event_EventCard = (EventCard);

// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
;// CONCATENATED MODULE: ./src/components/Wiki/Event/NoEventView.tsx







const WIKI_PATH_REGEX = /^(.*\/wiki\/.*)\/events$/;
const NoEventView = ()=>{
    var ref;
    const router = (0,next_router.useRouter)();
    const wikiPath = (ref = router.asPath.match(WIKI_PATH_REGEX)) === null || ref === void 0 ? void 0 : ref[1];
    const imageSrc = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("event-timeline-light.png", "event-timeline-dark.png");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        w: "100%",
        align: "center",
        justify: "center",
        direction: "column",
        pb: {
            base: "10",
            lg: "16"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            textAlign: "center",
            pb: 8,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                        ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                        w: "300px",
                        h: "300px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            imgBoxSize: 300,
                            alt: "No Events ",
                            src: "/images/GIFs/".concat(imageSrc),
                            w: "full",
                            objectFit: "contain"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    fontWeight: 500,
                    fontSize: {
                        base: "16px",
                        md: "18px"
                    },
                    color: "linkColor",
                    mt: "2",
                    children: "There are no records of events created for this wiki yet."
                }),
                wikiPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                    href: wikiPath,
                    mt: {
                        lg: "7",
                        base: "6"
                    },
                    children: "Back to wiki"
                })
            ]
        })
    });
};
/* harmony default export */ var Event_NoEventView = (NoEventView);

// EXTERNAL MODULE: ./src/pages/NotFound.tsx
var NotFound = __webpack_require__("./src/pages/NotFound.tsx");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/pages/wiki/[slug]/events.tsx









const Events = (param)=>{
    let { wiki  } = param;
    let eventContent;
    if (wiki) {
        if (!wiki.events || wiki.events.length === 0) {
            eventContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Event_NoEventView, {});
        } else if (wiki.events && wiki.events.length >= 1) {
            var ref;
            eventContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                gap: {
                    base: "6",
                    md: "10"
                },
                pos: "relative",
                pb: {
                    base: "10",
                    lg: "24"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        transform: "translateY(11px)",
                        pos: "absolute",
                        h: "100%",
                        w: "2px",
                        bgColor: "brandLinkColor",
                        left: {
                            base: "9px",
                            md: "11px"
                        },
                        top: "0px",
                        zIndex: "1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        alignItems: "center",
                        gap: "6",
                        pos: "relative",
                        zIndex: "2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                w: {
                                    base: "20px",
                                    md: "24px"
                                },
                                h: {
                                    base: "20px",
                                    md: "24px"
                                },
                                borderRadius: "50%",
                                bgColor: "brandLinkColor",
                                alignItems: "center",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                    color: "white",
                                    as: ri_index_esm/* RiCheckLine */.ffJ
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                color: "brandLinkColor",
                                fontSize: {
                                    base: "24px",
                                    md: "30px",
                                    xl: "36px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                    noOfLines: 1,
                                    maxW: "full",
                                    href: "/wiki/".concat(wiki.id),
                                    children: wiki === null || wiki === void 0 ? void 0 : wiki.title
                                })
                            })
                        ]
                    }),
                    wiki.events && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                        gap: {
                            base: "8",
                            xl: "16"
                        },
                        children: (ref = wiki.events) === null || ref === void 0 ? void 0 : ref.map((event, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Event_EventCard, {
                                link: event.link,
                                title: event.title,
                                eventDate: event.date,
                                description: event.description
                            }, i))
                    })
                ]
            });
        } else {
            eventContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Event_NoEventView, {});
        }
    } else {
        eventContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound["default"], {});
    }
    const SEOTitle = "".concat(wiki === null || wiki === void 0 ? void 0 : wiki.title, " timeline of events - IQ Wiki");
    const SEODescription = "Discover a comprehensive timeline of ".concat(wiki === null || wiki === void 0 ? void 0 : wiki.title, " events, milestones, and significant moments on IQ Wiki. Our meticulously curated timeline offers a chronological overview, providing valuable insights into the history and evolution of ").concat(wiki === null || wiki === void 0 ? void 0 : wiki.title, ". Explore key dates, noteworthy achievements, and impactful developments that have shaped ").concat(wiki === null || wiki === void 0 ? void 0 : wiki.title, ", allowing you to delve into its rich past and gain a deeper understanding of its significance.");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: SEOTitle,
                description: SEODescription,
                openGraph: {
                    title: SEOTitle,
                    description: SEODescription
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                bgColor: "pageBg",
                mt: -3,
                pt: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    w: {
                        base: "full",
                        md: "min(90%, 1100px)"
                    },
                    mx: "auto",
                    mt: {
                        base: "10",
                        lg: "16"
                    },
                    px: {
                        base: "3",
                        md: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            textAlign: "center",
                            children: "Timeline of Events"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            textAlign: "center",
                            pt: 4,
                            pb: 8,
                            color: "linkColor",
                            children: "A timeline of events for this wiki"
                        }),
                        eventContent
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var events = (Events);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,2192,7249,8764,5619,4095,8283,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fwiki%2F%5Bslug%5D%2Fevents.tsx&page=%2Fwiki%2F%5Bslug%5D%2Fevents!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);